<template>
  <div>
    <help-info-wrapper
      :info.sync="helpData"
      :service-name="serviceName"
      class="warp"
    >
      <template>
        <div class="testmain">
          <v-progress-circular v-if="loading" indeterminate color="primary" />
          <div v-else-if="categories.length > 0">
            <div
              v-for="(category, catIndex) in categories"
              :key="catIndex"
              class="category"
            >
              <h3>{{ category.name }}</h3>
              <div class="test">
                <div
                  v-for="(item, index) in category.elements"
                  :key="index"
                  class="element"
                >
                  <v-btn color="navy">{{ item.name }}</v-btn>
                  <help-info
                    :element-name="item.name"
                    :service-name="serviceName"
                    :helpData="helpData"
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-else class="no-data">
            <p>هیچ اطلاعاتی برای سرویس {{ serviceName }} یافت نشد.</p>
          </div>
        </div>
      </template>
    </help-info-wrapper>
  </div>
</template>

<script>
import HelpInfoWrapper from "./HelpInfoWrapper.vue";
import HelpInfo from "./HelpInfo.vue";
import { GetFile } from "./GuideContent_axios";

export default {
  name: "test_help_info",
  components: { HelpInfo, HelpInfoWrapper },
  data() {
    return {
      helpData: [],
      componentName: "test_help",
      serviceName: "Qrland",
      categories: [],
      loading: false,
    };
  },
  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      this.loading = true;

      GetFile(this.serviceName)
        .then((data) => {
          if (data.length > 0) {
            this.categories = this.processData(data[0]);
          }
        })
        .catch((error) => {
          console.error("خطا در دریافت داده‌ها:", error);
          this.categories = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    processData(data) {
      if (!data || data.length === 0) return [];
      const categoryMap = {};
      data.forEach((item) => {
        const catId = item.category_id || "Uncategorized";
        if (!categoryMap[catId]) {
          categoryMap[catId] = {
            name: item.category || `دسته ${catId}`,
            elements: [],
          };
        }
        categoryMap[catId].elements.push(item);
      });
      return Object.values(categoryMap);
    },
  },
};
</script>

<style scoped>
.testmain {
  display: flex;
  flex-direction: column;
  gap: 15px;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
}
.category {
  width: 100%;
}
.test {
  display: flex;
  flex-direction: row;
  gap: 5px;
  justify-content: flex-start;
  align-items: baseline;
  flex-wrap: wrap;
}
.element {
  display: flex;
  align-items: center;
  gap: 5px;
}
.no-data {
  text-align: center;
  color: #666;
}
.loading-wrapper {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 99;
  width: 100%;
  height: 100%;
}
</style>
